import * as React from "react"
import { StoreContext } from "../context/store-context"
import { css } from "@emotion/react"
import { useIntl } from "gatsby-plugin-react-intl"
import { device } from "../styles/device"

export function AddToCart({ variantId, quantity, available, ...props }) {
    const intl = useIntl()

    const { addVariantToCart, loading } = React.useContext(StoreContext)

    function addToCart(e) {
        e.preventDefault()
        addVariantToCart(variantId, quantity)
    }

    return (
        <button type="submit" onClick={addToCart} disabled={!available || loading} {...props} css={button}>
            {available ? intl.formatMessage({ id: "add_to_cart" }) : intl.formatMessage({ id: "out_of_stock" })}
        </button>
    )
}

const button = css`
    font-size: 1.33rem;
    width: 300px;
    padding: 1.4rem 0;
    color: white;
    background: black;
    border: solid 1px black;
    border-radius: none;
    cursor: pointer;
    &:hover {
        background: transparent;
        color: black;
        border: solid 1px black;
    }
    @media ${device.tb} {
        width: 30vw;
    }

    @media ${device.sp} {
        font-size: 1.55rem;
        width: 80vw;
        padding: 2rem 0;
    }
`
